export default "__VITE_ASSET__920998e8__"